import { Component, OnInit } from "@angular/core";
import { FormBuilder, Validators, FormGroup } from "@angular/forms";
import { DataService } from "src/app/shared/Services/data.service";
import { HttpClient } from "@angular/common/http";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import pdfMake from "pdfmake/build/pdfMake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import * as moment from "moment";
import * as momenttz from "moment-timezone";
import { ToastrService } from "ngx-toastr";
import { GetCurrentShift } from "src/app/shared/Services/getCurrentShift";
pdfMake.vfs = pdfFonts.pdfMake.vfs;
@Component({
  selector: "app-hourly-production-report",
  templateUrl: "./hourly-production-report.component.html",
  styleUrls: ["./hourly-production-report.component.scss"],
})
export class HourlyProductionReportComponent implements OnInit {
  hourlyProductionChart: any;
  productionChart: any;
  oeeChart: any;
  hourlyOee: any;
  timezone: any;
  custId;
  maxdate: any;
  mindate: any;
  action: any;
  toDate;
  fromDate: any;
  currentPage = 1;
  itemsPerPage = 5;
  pageSize;
  tablehourlyData: any = {};
  userDetails: any;
  selectedDepartment: any;
  exportViaMail: boolean = false;
  departmentData: any = [];
  showTable: boolean = false;
  breadCrumbItems: Array<{}>;
  pdfBool: boolean = false;
  csvBool: boolean = false;
  mailform: FormGroup;
  base64String;
  custName: any;
  settings = {};
  selectedMachine: any;
  machineData: any = [];
  chartDataURL: any;
  chartDataURLPie: any;
  reportType: any;
  selectedDepartmentShift: any = [];
  selectedShift: any;
  currentShiftData: any;
  shiftData: any = [];
  selectedDepartmentId: any;
  selectedShiftId: any;
  filterMachine: any = [];
  selectedMachineId: any;
  tableData: any = [];
  tableData2: any = [];
  hasBreakdown: boolean;
  hasInterlock: boolean;
  rows = [
    { key: 'Oee', label: 'OEE(%)' },
    { key: 'Availability', label: 'Availability(%)' },
    { key: 'Performance', label: 'Performance(%)' },
    { key: 'Quality', label: 'Quality(%)' },
    { key: 'Partplanned', label: 'Qty Planned' },
    { key: 'PartRejected', label: 'Qty Rejected' },
    { key: 'Running', label: 'Running (hr)' },
    { key: 'Idle', label: 'Idle (hr)' },
    { key: 'Breakdown', label: 'Breakdown (hr)' },
    { key: 'Interlock', label: 'Interlock (hr)' },
    { key: 'Off', label: 'Off (hr)' },
    { key: 'EnergyCost', label: 'Energy Cost ₹' },
    { key: 'ProductionCost', label: 'Production Cost ₹' },
    { key: 'OppertunityCost', label: 'Opportunity Cost ₹' },
    { key: 'Energy', label: 'Total Energy (kWh)' },
    { key: 'PartwiseEnergy', label: 'Partwise Energy (kWh)' },
    { key: 'Downtime', label: 'Downtime (hr)' }
  ];

  constructor(
    public formBuilder: FormBuilder,
    private dataservice: DataService,
    private http: HttpClient,
    private modalService: NgbModal,
    private toastr: ToastrService,
    private currShift: GetCurrentShift
  ) {
    this.userDetails = JSON.parse(sessionStorage.getItem("currentUser"));
    this.custId = this.userDetails["user"]["custId"];
    this.timezone = this.userDetails["user"]["timeZone"];
    this.custName = this.userDetails["user"]["name"];
  }
  ngOnInit(): void {
    this.breadCrumbItems = [
      { label: "K2" },
      { label: "Hourly Production Report", active: true },
    ];
    this.getDepartment();
    this.mailform = this.formBuilder.group({
      email: ["", [Validators.required, Validators.email]],
    });
    this.convertImageToBase64();
    this.auditLogs()
  }
  auditLogs() {
    let obj = {
      custID: this.custId
    }
    const subscription = this.dataservice
      .reportApi(
        "auditlog/hourlyreport",
        obj
      ).subscribe(
        (res) => {

        },
        (error) => {
          this.toastr.error("Server Unreachable", error);
        }
      );

  }
  convertImageToBase64() {
    const imagePath = "assets/wimera/Wimera_Logo_wSlogan_Green.png";
    this.http.get(imagePath, { responseType: "blob" }).subscribe(
      (data: Blob) => {
        const reader = new FileReader();
        reader.onloadend = () => {
          this.base64String = reader.result as string;
        };
        reader.readAsDataURL(data);
      },
      (error) => { }
    );
  }
  getDepartment() {
    this.departmentData = [];
    this.dataservice
      .get(`department?custId=${this.custId}`)
      .subscribe((res: any) => {
        if (res) {
          this.departmentData = res["data"];
          this.selectedDepartment = this.departmentData[0]["departmentName"];
          this.selectedDepartmentId = this.departmentData[0]["departmentId"];
          this.selectedDepartmentShift = this.departmentData[0]["shiftData"];
          this.shiftData = [
            { shiftName: "All Shift" },
            ...this.selectedDepartmentShift,
          ];
          this.selectedShift = "All Shift";
          this.selectedShiftId = "All Shift";
          this.currentShiftData = this.currShift.getCurrentShift(
            this.selectedDepartmentShift,
            this.timezone
          );
          if (this.currentShiftData && this.currentShiftData.currentDate) {
            const today = moment(this.currentShiftData.currentDate)
              .subtract(1, "days")
              .format("YYYY-MM-DD");
            this.maxdate = today;
            this.fromDate = today;
            this.getMachines();
          }
        }
      });
  }
  select_Department(value: any) {
    this.shiftData = [];
    const filter = this.departmentData.filter(
      (val) => val.departmentName === value
    );
    this.selectedDepartmentId = filter[0]["departmentId"];
    this.selectedDepartmentShift = filter[0]["shiftData"];
    this.shiftData = [
      { shiftName: "All Shift" },
      ...this.selectedDepartmentShift,
    ];
    this.selectedShift = "All Shift";
    this.selectedShiftId = "All Shift";
    this.currentShiftData = this.currShift.getCurrentShift(
      this.selectedDepartmentShift,
      this.timezone
    );
    if (this.currentShiftData && this.currentShiftData.currentDate) {
      const today = moment(this.currentShiftData.currentDate)
        .subtract(1, "days")
        .format("YYYY-MM-DD");
      this.maxdate = today;
      this.fromDate = today;
      this.getMachines();
    }
  }
  select_Shift(e: any) {
    this.tablehourlyData = []
    this.selectedShift = e;
    if (this.selectedShift != "All Shift") {
      const filtershift = this.selectedDepartmentShift?.filter(
        (val) => val.shiftName === this.selectedShift
      );
      this.selectedShiftId = filtershift[0]["usershiftId"];
    } else {
      this.selectedShiftId = "All Shift";
    }

    this.getData();
  }
  select_Date(e) {
    this.fromDate = e;
    this.toDate = e;
    this.getData();
  }
  getMachines() {
    this.machineData = [];
    this.filterMachine = [];
    this.dataservice
      .get(`api/device?custId=${this.custId}`)
      .subscribe((res) => {
        if (res) {
          this.machineData = res;
          this.filterMachine = this.machineData.filter(
            (val) => val.departmentName === this.selectedDepartment
          );
          if (this.filterMachine.length) {
            this.selectedMachine = this.filterMachine[0]["deviceName"];
            this.selectedMachineId = this.filterMachine[0]["deviceId"];
            this.getData();
          } else {
            this.tablehourlyData = [];
            this.showTable = false;
            this.tableData = [];
            this.gethourlyProductionChart(null, null);
            this.getproductionChart(null);
            this.gethourlyoeeChart(null, null);
            this.getoeeChart(null);
            this.toastr.warning("No Machine for this Department");
          }
        }
      });
  }
  select_Machine(value) {
    this.tablehourlyData = []
    this.selectedMachine = value;
    const filterMachine = this.machineData.filter(
      (val) => val.deviceName === this.selectedMachine
    );
    this.selectedMachineId = filterMachine[0]["deviceId"];

    this.getData();
  }
  hasPin2: boolean
  getData() {
    let param = {
      custId: this.custId,
      department: this.selectedDepartment,
      departmentId: this.selectedDepartmentId,
      date: this.fromDate,
      usershiftId: this.selectedShiftId,
      deviceId: this.selectedMachineId,
    };
    this.toastr.warning("please wait while fetching record");
    this.dataservice
      .reportApi(
        "reports/hourlyProduction",
        param
      )
      .subscribe(
        (res) => {
          if (res) {
            this.showTable = true;
            this.tablehourlyData = res["tablehourlyData"];
            if (
              this.tablehourlyData &&
              this.tablehourlyData.length > 0 &&
              Array.isArray(this.tablehourlyData[0]["partwiseData"]) &&
              this.tablehourlyData[0]["partwiseData"].length > 0 &&
              this.tablehourlyData[0]["hourArray"].length > 0
            ) {

              // this.hasBreakdown = this.tablehourlyData?.[0]?.BreakdownTime !== undefined;
              // this.hasInterlock = this.tablehourlyData?.[0]?.InterlockTime !== undefined;
              this.hasBreakdown = this.tablehourlyData?.[0]?.partwiseData?.[0]?.hasOwnProperty('Breakdown') ?? false;
              this.hasInterlock = this.tablehourlyData?.[0]?.partwiseData?.[0]?.hasOwnProperty('Interlock') ?? false;
              this.hasPin2 = this.tablehourlyData?.[0]?.partwiseData?.[0]?.hasOwnProperty('Pin2Count') ?? false;


              this.tableData = this.tablehourlyData[0]["partwiseData"];
              this.tableData[0]['PartwiseEnergy'] = []
              if (this.tableData.length > 0) {
                const row = this.tableData[0];

                row.PartwiseEnergy =
                  row.Energy?.map((val: number, i: number) =>
                    row.PartProduced?.[i]
                      ? (val / row.PartProduced[i]).toFixed(2)
                      : '0'
                  ) || [];

                this.gethourlyProductionChart(
                  this.tablehourlyData[0],
                  this.tableData[0]
                );
                this.getproductionChart(this.tableData[0]);
                this.gethourlyoeeChart(
                  this.tablehourlyData[0],
                  this.tableData[0]
                );
                this.getoeeChart(this.tableData[0]);
              }
            } else {
              this.tablehourlyData = [];
              this.tableData = [];
              this.gethourlyProductionChart(null, null);
              this.getproductionChart(null);
              this.gethourlyoeeChart(null, null);
              this.getoeeChart(null);
              this.toastr.warning("No data available for the selected Date");
              this.showTable = false;
            }
          } else {
            this.tableData = [];
            this.tablehourlyData = [];
            this.gethourlyProductionChart(null, null);
            this.getproductionChart(null);
            this.gethourlyoeeChart(null, null);
            this.getoeeChart(null);
            this.toastr.warning("No data available for the selected Date");
            this.showTable = false;
          }
        },
        (err) => {
          this.toastr.error("No data available for the selected Date");
          this.tableData = [];
          this.tablehourlyData = [];
          this.gethourlyProductionChart(null, null);
          this.getproductionChart(null);
          this.gethourlyoeeChart(null, null);
          this.getoeeChart(null);
          this.showTable = false;
        }
      );
  }

  // get displayRows() {
  //   return this.rows.filter(row => {
  //     if (row.key === 'Breakdown' && !this.hasBreakdown) return false;
  //     if (row.key === 'Interlock' && !this.hasInterlock) return false;
  //   if (this.hasPin2) {
  //     if (row.key === 'PartProduced') return false;
  //   } else {
  //     if (row.key === 'Pin1Count') return false;
  //     if (row.key === 'Pin2Count') return false;
  //   }
  //     return true;
  //   });
  // }
  get displayRows() {
    let dynamicRows = [...this.rows];
    const partPlannedIndex = dynamicRows.findIndex(r => r.key === 'Partplanned');

    if (this.hasPin2) {
      dynamicRows.splice(partPlannedIndex + 1, 0,
        { key: 'Pin1Count', label: 'Partcount 1' },
        { key: 'Pin2Count', label: 'Partcount 2' }
      );
    } else {
      dynamicRows.splice(partPlannedIndex + 1, 0,
        { key: 'Pin1Count', label: 'Qty Produced' }
      );
    }

    return dynamicRows.filter(row => {
      if (row.key === 'Breakdown' && !this.hasBreakdown) return false;
      if (row.key === 'Interlock' && !this.hasInterlock) return false;
      return true;
    });
  }


  gethourlyoeeChart(hourdata: any, data: any) {
    if (
      !data ||
      !Array.isArray(hourdata["hourArray"]) ||
      hourdata["hourArray"].length === 0 ||
      !Array.isArray(data.Availability) ||
      data.Availability.length === 0 ||
      !Array.isArray(data.Performance) ||
      data.Performance.length === 0 ||
      !Array.isArray(data.Quality) ||
      data.Quality.length === 0 ||
      !Array.isArray(data.Oee) ||
      data.Oee.length === 0
    ) {
      this.hourlyOee = {
        title: {
          text: "No Data Available",
          left: "center",
          top: "middle",
          textStyle: {
            color: "#999",
            fontSize: 16,
            fontWeight: "bold",
          },
        },
        xAxis: { show: false },
        yAxis: { show: false },
        series: [],
      };
      return;
    }
    this.hourlyOee = {
      title: {
        text: "Hourly Oee",
        left: "left",
        top: "top",
        textStyle: {
          fontSize: 14,
          fontWeight: "bold",
        },
      },
      grid: {
        left: "5%",
        right: "5%",
        bottom: "10%",
        top: "20%",
        containLabel: true,
      },
      toolbox: {
        feature: {
          restore: {
            title: "Reset",
          },
        },
      },
      xAxis: {
        type: "category",
        data: hourdata["hourArray"],
        name: "Hour",
        nameLocation: "middle",
        nameGap: 20,
        axisLine: {
          lineStyle: {
            color: "#333",
          },
        },
        axisLabel: {
          rotate: 0,
          fontSize: 9,

          formatter: function (value) {
            return value.split(" - ")[1];
          },
        },
      },
      yAxis: {
        type: "value",
        name: "(%)",
        nameLocation: "middle",
        nameGap: 30,
        axisLine: {
          lineStyle: {
            color: "#333",
          },
        },
      },
      legend: {
        orient: "horizontal",
        left: "center",
        data: ["Availability", "Performance", "Quality", "OEE"],
        top: -5,
        textStyle: {
          fontSize: 10,
        },
        itemWidth: 10,
        itemHeight: 10,
      },
      tooltip: {
        trigger: "axis",
        backgroundColor: "#fff",
        borderColor: "#ccc",
        borderWidth: 1,
        textStyle: { color: "#333", fontSize: 12 },
        formatter: (params) => {
          const idx = params[0].dataIndex;

          const parts = [
            {
              name: "Availability",
              value: data.Availability[idx],
              color: "#4CAF50",
            },
            {
              name: "Performance",
              value: data.Performance[idx],
              color: "#FF9800",
            },
            { name: "Quality", value: data.Quality[idx], color: "#2196F3" },
            { name: "OEE", value: data.Oee[idx], color: "#9C27B0" },
          ];

          let tooltipText = `<b>Hour: ${params[0].axisValue}</b><br/>`;
          parts.forEach((item) => {
            tooltipText += `
        <span style="
          display:inline-block;
          margin-right:5px;
          border-radius:10px;
          width:9px;
          height:9px;
          background-color:${item.color};
        "></span>
        <span>${item.name}: ${item.value} %</span><br/>
      `;
          });

          return tooltipText;
        },
      },

      dataZoom: [
        {
          type: "slider",
          show: false,
          xAxisIndex: [0],
          start: 0,
          end: 100,
          height: 20,
          bottom: 10,
        },
        {
          type: "inside",
          xAxisIndex: [0],
          start: 0,
          end: 100,
        },
      ],
      series: [
        {
          name: "Availability",
          data: data.Availability,
          type: "bar",
          itemStyle: {
            color: "#4CAF50",
          },
          backgroundStyle: {
            color: "rgba(180, 180, 180, 0.2)",
          },
        },
        {
          name: "Performance",
          data: data.Performance,
          type: "bar",
          itemStyle: {
            color: "#FF9800",
          },
          backgroundStyle: {
            color: "rgba(180, 180, 180, 0.2)",
          },
        },
        {
          name: "Quality",
          data: data.Quality,
          type: "bar",
          itemStyle: {
            color: "#2196F3",
          },
          backgroundStyle: {
            color: "rgba(180, 180, 180, 0.2)",
          },
        },
        {
          name: "OEE",
          data: data.Oee,
          type: "line",
          itemStyle: {
            color: "#9C27B0",
          },
          backgroundStyle: {
            color: "rgba(180, 180, 180, 0.2)",
          },
          label: {
            show: true,
            position: "top",
            color: "#000",
            fontWeight: "bold",
            formatter: function (params) {
              return params.value === 0 ? "" : `${params.value}%`;
            },
          },
        },
      ],
    };
  }
  getoeeChart(data: any) {
    if (
      !data ||
      !Array.isArray(data.Availability) ||
      data.Availability.length === 0 ||
      !Array.isArray(data.Performance) ||
      data.Performance.length === 0 ||
      !Array.isArray(data.Quality) ||
      data.Quality.length === 0 ||
      !Array.isArray(data.Oee) ||
      data.Oee.length === 0
    ) {
      this.oeeChart = {
        title: {
          text: "No Data Available",
          left: "center",
          top: "middle",
          textStyle: {
            color: "#999",
            fontSize: 16,
            fontWeight: "bold",
          },
        },
        xAxis: { show: false },
        yAxis: { show: false },
        series: [],
      };
      return;
    }
    const availability = +(
      data.Availability.reduce((acc: number, val: number) => acc + val, 0) /
      data.Availability.length
    ).toFixed(2);

    const performance = +(
      data.Performance.reduce((acc: number, val: number) => acc + val, 0) /
      data.Performance.length
    ).toFixed(2);

    const quality = +(
      data.Quality.reduce((acc: number, val: number) => acc + val, 0) /
      data.Quality.length
    ).toFixed(2);

    const oee = +(
      data.Oee.reduce((acc: number, val: number) => acc + val, 0) /
      data.Oee.length
    ).toFixed(2);

    this.oeeChart = {
      title: {
        text: "OEE",
        left: "left",
        top: "top",
        textStyle: {
          fontSize: 14,
          fontWeight: "bold",
        },
      },
      grid: {
        top: "20%",
        right: "5%",
        bottom: "0%",
        left: "5%",
        containLabel: true,
      },
      tooltip: {
        trigger: "axis",
        axisPointer: { type: "shadow" },
        backgroundColor: "#fff",
        borderColor: "#ccc",
        borderWidth: 1,
        textStyle: { color: "#333", fontSize: 12 },
        formatter: () => {
          const parts = [
            { name: "Availability", value: availability, color: "#4CAF50" },
            { name: "Performance", value: performance, color: "#FF9800" },
            { name: "Quality", value: quality, color: "#2196F3" },
            { name: "OEE", value: oee, color: "#9C27B0" },
          ];

          let tooltipText = `<b>OEE Metrics</b><br/>`;
          parts.forEach((item) => {
            tooltipText += `
        <span style="
          display:inline-block;
          margin-right:5px;
          border-radius:50%;
          width:9px;
          height:9px;
          background-color:${item.color};
        "></span>
        <span>${item.name}: ${item.value}%</span><br/>
      `;
          });

          return tooltipText;
        },
      },

      xAxis: {
        type: "category",
        data: ["Availability", "Performance", "Quality", "OEE"],
        axisLabel: {
          fontSize: 12,
          interval: 0,
          rotate: 20,
          fontWeight: "bold",
        },
      },

      yAxis: {
        type: "value",
        max: 100,
      },
      series: [
        {
          data: [
            { value: availability, itemStyle: { color: "#4CAF50" } },
            { value: performance, itemStyle: { color: "#FF9800" } },
            { value: quality, itemStyle: { color: "#2196F3" } },
            { value: oee, itemStyle: { color: "#9C27B0" } },
          ],
          type: "bar",
          label: {
            show: true,
            position: "top",
            formatter: "{c}%",
            color: "#000",
            fontSize: 12,
          },
        },
      ],
    };
  }
  gethourlyProductionChart(hourdata: any, data: any) {
    if (
      !data ||
      !Array.isArray(hourdata["hourArray"]) ||
      hourdata["hourArray"].length === 0 ||
      !Array.isArray(data.PartProduced) ||
      data.PartProduced.length === 0 ||
      !Array.isArray(data.PartRejected) ||
      data.PartRejected.length === 0
    ) {
      this.hourlyProductionChart = {
        title: {
          text: "No Data Available",
          left: "center",
          top: "middle",
          textStyle: {
            color: "#999",
            fontSize: 16,
            fontWeight: "bold",
          },
        },
        xAxis: { show: false },
        yAxis: { show: false },
        series: [],
      };
      return;
    }
    this.hourlyProductionChart = {
      title: {
        text: "Hourly Partcount",
        left: "left",
        top: "top",
        textStyle: {
          fontSize: 14,
          fontWeight: "bold",
        },
      },
      grid: {
        left: "5%",
        right: "6%",
        bottom: "10%",
        top: "25%",
        containLabel: true,
      },
      toolbox: {
        feature: {
          restore: {
            title: "Reset",
          },
        },
      },
      xAxis: {
        type: "category",
        data: hourdata["hourArray"],
        name: "Hour",
        nameLocation: "middle",
        nameGap: 20,
        axisLine: {
          lineStyle: {
            color: "#333",
          },
        },
        axisLabel: {
          rotate: 0,
          fontSize: 9,
          formatter: function (value) {
            return value.split(" - ")[1];
          },
        },
      },
      yAxis: {
        type: "value",
        name: "Quantity",
        nameLocation: "middle",
        nameGap: 40,
        axisLine: {
          lineStyle: {
            color: "#333",
          },
        },
      },
      legend: {
        orient: "horizontal",
        left: "center",
        data: ["Planned", "Produced", "Rejected"],
        top: 0,
        textStyle: {
          fontSize: 10,
        },
        itemWidth: 10,
        itemHeight: 10,
      },
      tooltip: {
        trigger: "axis",
        backgroundColor: "#fff",
        borderColor: "#ccc",
        borderWidth: 1,
        textStyle: { color: "#333", fontSize: 12 },
        formatter: (params) => {
          const idx = params[0].dataIndex;

          const parts = [
            { name: "Planned", value: data.Partplanned[idx], color: "#009688" },
            {
              name: "Produced",
              value: data.PartProduced[idx],
              color: "#4CAF50",
            },
            {
              name: "Rejected",
              value: data.PartRejected[idx],
              color: "#F44336",
            },
          ];

          let tooltipText = `<b>Hour: ${params[0].axisValue}</b><br/>`;
          parts.forEach((item) => {
            tooltipText += `
        <span style="
          display:inline-block;
          margin-right:5px;
          border-radius:10px;
          width:9px;
          height:9px;
          background-color:${item.color};
        "></span>
        <span>${item.name}: ${item.value}</span><br/>
      `;
          });

          return tooltipText;
        },
      },

      dataZoom: [
        {
          type: "slider",
          show: false,
          xAxisIndex: [0],
          start: 0,
          end: 100,
          height: 20,
          bottom: 10,
        },
        {
          type: "inside",
          xAxisIndex: [0],
          start: 0,
          end: 100,
        },
      ],
      series: [
        {
          name: "Part Produced",
          data: data.PartProduced,
          type: "bar",
          itemStyle: {
            color: "#4CAF50",
          },
          backgroundStyle: {
            color: "rgba(180, 180, 180, 0.2)",
          },
          label: {
            show: true,
            position: "top",
            color: "#000",
            fontWeight: "bold",
            formatter: function (params) {
              return params.value === 0 ? "" : params.value;
            },
          },
          markPoint: {
            symbol: "pin",
            symbolSize: 30,
            itemStyle: { color: "#E53935" },
            label: {
              color: "#fff",
              fontWeight: "bold",
            },
            data: data.PartRejected.map((value, index) => {
              if (value > 0) {
                return {
                  name: "Reject",
                  value: value,
                  xAxis: index,
                  yAxis: value,
                };
              }
              return null;
            }).filter((item) => item !== null),
          },
        },
        {
          name: "Part Planned",
          type: "line",
          data: data.Partplanned,
          symbol: "circle",
          symbolSize: 2,
          lineStyle: {
            color: "#009688",
            type: "dashed",
            width: 2,
          },
          itemStyle: {
            color: "#009688",
          },
          label: {
            show: false,
          },
        },
      ],
    };
  }
  formatMinutesToHHMMSS(minutes: number): string {
    if (isNaN(minutes) || minutes < 0 || !isFinite(minutes)) {
      return "00:00:00";
    }

    const totalSeconds = Math.floor(minutes * 60);
    const hours = Math.floor(totalSeconds / 3600);
    const mins = Math.floor((totalSeconds % 3600) / 60);
    const secs = totalSeconds % 60;

    const pad = (n: number) => String(n).padStart(2, "0");
    return `${pad(hours)}:${pad(mins)}:${pad(secs)}`;
  }
  getproductionChart(data: any) {
    if (
      !data ||
      !Array.isArray(data.Running) ||
      data.Running.length === 0 ||
      !Array.isArray(data.Idle) ||
      data.Idle.length === 0 ||
      !Array.isArray(data.Off) ||
      data.Off.length === 0
    ) {
      this.productionChart = {
        title: {
          text: "No Data Available",
          left: "center",
          top: "middle",
          textStyle: {
            color: "#999",
            fontSize: 16,
            fontWeight: "bold",
          },
        },
        xAxis: { show: false },
        yAxis: { show: false },
        series: [],
      };
      return;
    }

    const totalRunning = data.Running.reduce(
      (acc: number, val: number) => acc + val,
      0
    );
    const totalIdle = data.Idle.reduce(
      (acc: number, val: number) => acc + val,
      0
    );
    let totalBreakdown;
    if (data.hasOwnProperty('Breakdown')) {
      totalBreakdown = data?.Breakdown?.reduce(
        (acc: number, val: number) => acc + val,
        0
      );
    }
    let totalInterlock;
    if (data.hasOwnProperty('Interlock')) {
      totalInterlock = data?.Interlock?.reduce(
        (acc: number, val: number) => acc + val,
        0
      );
    }
    const totalOff = data.Off.reduce(
      (acc: number, val: number) => acc + val,
      0
    );
    let legendData = ["Running", "Idle", "Off"];
    if (data.hasOwnProperty('Breakdown')) {
      legendData.push("Breakdown")
    }
    if (data.hasOwnProperty('Interlock')) {
      legendData.push("Interlock")
    }

    this.productionChart = {
      title: {
        text: "Production Summary",
        left: "left",
        top: "top",
        textStyle: {
          fontSize: 14,
          fontWeight: "bold",
        },
      },
      tooltip: {
        trigger: "item",
        backgroundColor: "#fff",
        borderColor: "#ccc",
        borderWidth: 1,
        textStyle: { color: "#333", fontSize: 12 },
        formatter: () => {
          let parts = [
            { name: "Running", value: totalRunning, color: "#548237" },
            { name: "Idle", value: totalIdle, color: "#f7c030" },

            { name: "Off", value: totalOff, color: "#b0b0b0" },
          ];
          if (data.hasOwnProperty('Breakdown')) {
            parts.push({ name: "Breakdown", value: totalBreakdown, color: "#eb5857" })
          }
          if (data.hasOwnProperty('Interlock')) {
            parts.push({ name: "Interlock", value: totalInterlock, color: "#7B542F" })
          }
          let tooltipText = `<b>Production Summary</b><br/>`;
          parts.forEach((item: any) => {
            tooltipText += `
      <span style="display:inline-block;margin-right:5px;
        border-radius:10px;width:9px;height:9px;
        background-color:${item.color};"></span>
      <span>${item.name}: ${this.formatMinutesToHHMMSS(
              item.value
            )}</span><br/>`;
          });

          return tooltipText;
        },
      },
      legend: {
        orient: "horizontal",
        left: "center",
        data: legendData,
        bottom: 0,
        textStyle: {
          fontSize: 10,
        },
        itemWidth: 10,
        itemHeight: 10,
      },
      series: [
        {
          name: "Production",
          type: "pie",
          radius: ["40%", "70%"], // donut
          avoidLabelOverlap: false,
          label: {
            show: false,
          },
          labelLine: {
            show: false,
          },
          data: [
            {
              value: totalRunning,
              name: "Running",
              itemStyle: { color: "#548237" },
            },
            {
              value: totalIdle,
              name: "Idle",
              itemStyle: { color: "#f7c030" },
            },
            {
              value: totalBreakdown,
              name: "Breakdown",
              itemStyle: { color: "#eb5857" },
            },
            {
              value: totalInterlock,
              name: "Interlock",
              itemStyle: { color: "#7B542F" },
            },
            {
              value: totalOff,
              name: "Off",
              itemStyle: { color: "#b0b0b0" },
            },
          ],
          itemStyle: {
            borderRadius: 5,
            borderColor: "#fff",
            borderWidth: 2,
          },
        },
      ],
    };
  }
  openModal(templatepdf: any, data: any, act: any) {
    this.action = act;
    this.modalService.open(templatepdf, { centered: true });
  }
  get email() {
    return this.mailform.get("email");
  }
  mailexport() {
    this.pdfBool = false;
    this.csvBool = false;
    this.exportViaMail = true;
  }
  directExpo() {
    this.exportViaMail = false;
    this.pdfBool = false;
    this.csvBool = false;
    this.mailform.reset();
  }
  isEmailInvalid() {
    return this.email.invalid && (this.email.dirty || this.email.touched);
  }
  ngOnDestroy() { }
  onPageChange(pageNum: number): void {
    this.pageSize = this.itemsPerPage * (pageNum - 1);
  }
  pdf() {
    this.pdfBool = true;
    this.csvBool = false;
  }
  csv() {
    this.csvBool = true;
    this.pdfBool = false;
  }
  cancel() {
    this.pdfBool = false;
    this.csvBool = false;
    this.mailform.reset();
    this.exportViaMail = false;
  }
  oeechartInstance: any;
  onoeeChartInit(ec: any) {
    this.oeechartInstance = ec;
  }
  oeehourlychartInstance: any;
  onoeehourlyChartInit(ec: any) {
    this.oeehourlychartInstance = ec;
  }
  partcounthourlychartInstance: any;
  onpartcounthourlyChartInit(ec: any) {
    this.partcounthourlychartInstance = ec;
  }
  productioncounthourlychartInstance: any
  onproductioncounthourlyChartInit(ec: any) {
    this.productioncounthourlychartInstance = ec;
  }
  download() {
    if (!this.pdfBool && !this.csvBool) this.pdfBool = true;
    var reportDate = momenttz.tz(this.timezone).format("YYYY-MM-DD HH:mm:ss");

    if (
      this.pdfBool &&
      this.base64String !== undefined &&
      !this.exportViaMail
    ) {
      const oeechartImage = this.oeechartInstance?.getDataURL({
        type: 'png',
        pixelRatio: 2,
        backgroundColor: '#fff'
      });
      const oeehourlychartImage = this.oeehourlychartInstance?.getDataURL({
        type: 'png',
        pixelRatio: 2,
        backgroundColor: '#fff'
      });
      const partcounthourlychartImage = this.partcounthourlychartInstance?.getDataURL({
        type: 'png',
        pixelRatio: 2,
        backgroundColor: '#fff'
      });
      const productioncounthourlychartImage = this.productioncounthourlychartInstance?.getDataURL({
        type: 'png',
        pixelRatio: 2,
        backgroundColor: '#fff'
      });

      this.reportType = "Day";
      var pdfName = "Hourly Production Report " + reportDate;
      var today = moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
      var year = moment(new Date()).format("YYYY");

      const parameterKeys = [
        "Availability",
        "Performance",
        "Quality",
        "Oee",
        "Partplanned",
        // "PartProduced",
        ...(this.hasPin2 ? ["Pin1Count", "Pin2Count"] : ["PartProduced"]),
        "PartRejected",
        "Energy",
        "PartwiseEnergy",
        "EnergyCost",
        "OppertunityCost",
        "ProductionCost",
        "Running",
        "Idle",
        ...(this.hasBreakdown ? ["Breakdown"] : []),
        ...(this.hasInterlock ? ["Interlock"] : []),
        "Off",
        "Downtime",
      ];
      const parameterMap = [
        "Availability(%)",
        "Performance(%)",
        "Quality(%)",
        "Oee(%)",
        "PlannedPart",
        // "PartProduced",
        ...(this.hasPin2 ? ["Pin1Count", "Pin2Count"] : ["PartProduced"]),
        "PartRejected",
        "Energy (kWh)",
        "Partwise Energy(kWh)",
        "EnergyCost (₹)",
        "OpportunityCost (₹)",
        "ProductionCost (₹)",
        "Running(hrs)",
        "Idle(hrs)",
        ...(this.hasBreakdown ? ["Breakdown(hrs)"] : []),
        ...(this.hasInterlock ? ["Interlock(hrs)"] : []),
        "Off(hrs)",
        "Downtime(hrs)",
      ];
      const headerRow = [
        {
          text: "Parameter",
          fillColor: "#007d79",
          bold: true,
          color: "#fff",
          alignment: "center",
          noWrap: true,
        },
        ...this.tablehourlyData[0].hourArray.map((hour) => ({
          text: hour,
          fillColor: "#007d79",
          color: "#fff",
          bold: true,
          alignment: "center",
        })),
      ];
      const timeFields = ["Running", "Idle", ...(this.hasBreakdown ? ["Breakdown"] : []), ...(this.hasInterlock ? ["Interlock"] : []), "Off", "Downtime"];
      const bodyRows = parameterKeys.map((param, index) => {
        const values = this.tableData[0][param] || [];
        return [
          { text: parameterMap[index], bold: true },
          ...values.map((val) => ({
            text: timeFields.includes(param)
              ? this.formatMinutesToHHMMSS(val)
              : val.toString(),
            alignment: "center",
          })),
        ];
      });
      const tableBody = [headerRow, ...bodyRows];

      const pdfObject = {
        pageSize: "A3",
        pageOrientation: "landscape",
        header: function () {
          return [
            {
              text: today,
              alignment: "right",
              margin: [0, 5, 20, 0],
              fontSize: 10,
            },
          ];
        },
        footer: function (currentPage, pageCount) {
          return [
            {
              text: "Page " + currentPage.toString() + " of " + pageCount,
              alignment: "center",
              fontSize: 7,
            },
            {
              text: "© " + year + " Wimera Systems Pvt Ltd",
              alignment: "right",
              fontSize: 7,
              margin: [5, 2, 10, 20],
            },
          ];
        },
        content: [
          {
            columns: [
              {
                image: `${this.base64String}`,
                width: 140,
                height: 45,
                alignment: "left",
                margin: [-30, -28, 0, 0],
              },
            ],
          },
          {
            columns: [
              {
                text: "HOURLY PRODUCTION REPORT",
                fontSize: 15,
                bold: true,
                alignment: "center",
                margin: [0, -35, 0, 0],
              },
            ],
          },
          {
            columns: [
              {
                text: "(Date :  " + this.fromDate + ")",
                margin: [0, -10, 0, 0],
                fontSize: 10,
                bold: true,
                alignment: "center",
              },
            ],
          },
          {
            canvas: [
              {
                type: "line",
                lineColor: "#007d79",
                x1: -40,
                y1: 0,
                x2: 2000,
                y2: 0,
                linewidth: 0.05,
              },
            ],
            margin: [0, 0, 0, 10],
          },
          {
            text: "Department : " + this.selectedDepartment,
            fontSize: 12,
            bold: true,
            margin: [0, 0, 0, 10],
          },
          {
            text: "Shift : " + this.selectedShift,
            fontSize: 12,
            bold: true,
            margin: [0, 0, 0, 10],
          },
          {
            text: "MachineName : " + this.selectedMachine,
            fontSize: 12,
            bold: true,
            margin: [0, 0, 0, 10],
          },
          {
            columns: [
              {
                image: oeechartImage,
                width: 250,
                margin: [0, 5, 10, 20],
              },
              {
                image: oeehourlychartImage,
                width: 850,
                margin: [10, 5, 0, 20],
              },
            ],
          },
          {
            columns: [
              {
                image: partcounthourlychartImage,
                width: 750,
                height: 170,
                margin: [0, 5, 10, 20],
              },
              {
                image: productioncounthourlychartImage,
                width: 200,
                margin: [10, 5, 0, 20],
              },
              {
                // text: `Running Time: ${this.formatMinutesToHHMMSS(this.tablehourlyData[0].RunningTime)}\nIdle Time: ${this.formatMinutesToHHMMSS(this.tablehourlyData[0].IdleTime)}\nBreakdown Time: ${this.formatMinutesToHHMMSS(this.tablehourlyData[0].BreakdownTime)}\nInterlock Time: ${this.formatMinutesToHHMMSS(this.tablehourlyData[0].InterlockTime)}\nOff Time: ${this.formatMinutesToHHMMSS(this.tablehourlyData[0].OffTime)}\n`,
                text: [
                  `Running Time: ${this.formatMinutesToHHMMSS(this.tablehourlyData[0].RunningTime)}`,
                  `Idle Time: ${this.formatMinutesToHHMMSS(this.tablehourlyData[0].IdleTime)}`,
                  this.hasBreakdown
                    ? `Breakdown Time: ${this.formatMinutesToHHMMSS(this.tablehourlyData[0].BreakdownTime)}`
                    : null,
                  this.hasInterlock
                    ? `Interlock Time: ${this.formatMinutesToHHMMSS(this.tablehourlyData[0].InterlockTime)}`
                    : null,
                  `Off Time: ${this.formatMinutesToHHMMSS(this.tablehourlyData[0].OffTime)}`
                ].filter(Boolean).join('\n'),

                fontSize: 10,
                bold: true,
                alignment: 'left',
                margin: [0, 70, 0, 10],
              },
            ],
          },

          {
            fontSize: 8,
            margin: [0, 0, 0, 0],
            table: {
              headerRows: 1,
              widths: [
                "auto",
                ...this.tablehourlyData[0].hourArray.map(() => "auto"),
              ],
              body: tableBody,
            },
            defaultStyle: {
              font: "Roboto",
            },
            layout: {
              fillColor: function (rowIndex) {
                return rowIndex === 0
                  ? null
                  : rowIndex % 2 === 0
                    ? "#9ef0f0"
                    : "#d9fbfb";
              },
              hLineWidth: function (i, node) {
                return i === 0 || i === node.table.body.length ? 0.1 : 0.1;
              },
              vLineWidth: function (i, node) {
                return i === 0 || i === node.table.widths.length ? 0.1 : 0.1;
              },
            },
          },
        ],
      };

      // Download the PDF
      pdfMake.createPdf(pdfObject).download(pdfName + ".pdf");
    } else if (this.csvBool && !this.exportViaMail) {
      var res = [];
      var masterhourlyData = this.tablehourlyData;
      var title = "Hourly Production Report";
      var department = ["Department Name: " + this.selectedDepartment, "\n"];
      var shift = ["Shift: " + this.selectedShift, "\n"];
      var machine = ["Machine Name: " + this.selectedMachine, "\n"];

      var startDate = moment(this.fromDate).format("YYYY-MM-DD");
      var duration = "Date : " + startDate;
      var details = [title, "\n"];
      var durationData = [duration, "\n"];

      res.push(details);
      res.push(durationData);
      res.push(department);
      res.push(shift);
      res.push(machine);

      const parameterKeys = [
        "Availability",
        "Performance",
        "Quality",
        "Oee",
        "Partplanned",
        // "PartProduced",
        ...(this.hasPin2 ? ["Pin1Count", "Pin2Count"] : ["PartProduced"]),
        "PartRejected",
        "Energy",
        "PartwiseEnergy",
        "EnergyCost",
        "OppertunityCost",
        "ProductionCost",
        "Running",
        "Idle",
        ...(this.hasBreakdown ? ["Breakdown"] : []),
        ...(this.hasInterlock ? ["Interlock"] : []),
        "Off",
        "Downtime",
      ];

      const parameterMap = [
        "Availability(%)",
        "Performance(%)",
        "Quality(%)",
        "Oee(%)",
        "PlannedPart",
        // "PartProduced",
        ...(this.hasPin2 ? ["Pin1Count", "Pin2Count"] : ["PartProduced"]),
        "PartRejected",
        "Energy (kWh)",
        "Partwise Energy (kWh)",
        "EnergyCost (INR)",
        "OpportunityCost (INR)",
        "ProductionCost (INR)",
        "Running(hrs)",
        "Idle(hrs)",
        ...(this.hasBreakdown ? ["Breakdown(hrs)"] : []),
        ...(this.hasInterlock ? ["Interlock(hrs)"] : []),
        "Off(hrs)",
        "Downtime(hrs)",
      ];

      const timeFields = ["Running", "Idle", ...(this.hasBreakdown ? ["Breakdown"] : []), ...(this.hasInterlock ? ["Interlock"] : []), "Off", "Downtime"];
      // 1. Header Row for CSV
      let hourHeaderRow = ["Parameter", ...masterhourlyData[0].hourArray];
      res.push(hourHeaderRow);

      // 2. Data Rows
      for (let i = 0; i < parameterKeys.length; i++) {

        const key = parameterKeys[i];
        const label = parameterMap[i];
        const values = masterhourlyData[0]["partwiseData"][0][key] || [];
        const row = [
          label,
          ...values.map((val) =>
            timeFields.includes(key)
              ? this.formatMinutesToHHMMSS(val) // You should define this function globally
              : val.toString()
          ),
        ];

        res.push(row);
      }

      // 3. CSV Download Logic
      const downloadConfigration = {
        fileName: "Hourly Production Reports",
        res: res,
      };

      const csvdata = downloadConfigration.res;
      const csvContent =
        "data:text/csv;charset=utf-8," +
        csvdata.map((e) => e.join(",")).join("\n");

      const encodedUri = encodeURI(csvContent);
      const link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      const downloadDate = moment(new Date()).format("YYYY-MM-DD HH_mm_ss");
      link.setAttribute(
        "download",
        `${downloadConfigration.fileName} ${downloadDate}.csv`
      );
      document.body.appendChild(link);
      link.click();
    } else if (this.pdfBool && this.exportViaMail) {

      let data = this.mailform.value;
      let maildata = {};
      (maildata["to"] = data["email"]),
        (maildata["hourData"] = this.tableData),
        (maildata["hourArray"] = this.tablehourlyData[0]["hourArray"]),
        (maildata["reportname"] = "HourlyProductionReports"),
        (maildata["departmentName"] = this.selectedDepartment),
        (maildata["shiftName"] = this.selectedShift),
        (maildata["machineName"] = this.selectedMachine),
        (maildata["fromDate"] = this.fromDate),
        (maildata["customerName"] = this.custName),
        (maildata["filetype"] = "pdf");
      this.toastr.info("please wait while processing");
      this.dataservice.post("api/sendMail", maildata).subscribe(
        (res) => {
          this.toastr.success("Mail sent successfully!");
        },
        (err) => {
          this.toastr.error(err.message);
        }
      );
    } else if (this.csvBool && this.exportViaMail) {
      let data = this.mailform.value;
      let maildata = {};
      (maildata["to"] = data["email"]),
        (maildata["hourData"] = this.tableData),
        (maildata["hourArray"] = this.tablehourlyData[0]["hourArray"]),
        (maildata["reportname"] = "HourlyProductionReports"),
        (maildata["departmentName"] = this.selectedDepartment),
        (maildata["shiftName"] = this.selectedShift),
        (maildata["machineName"] = this.selectedMachine),
        (maildata["fromDate"] = this.fromDate),
        (maildata["customerName"] = this.custName),
        (maildata["filetype"] = "csv");
      this.toastr.info("please wait while processing");
      this.dataservice.post("api/sendMail", maildata).subscribe(
        (res) => {
          this.toastr.success("Mail sent successfully!");
        },
        (err) => {
          this.toastr.error(err.message);
        }
      );
    }
    this.pdfBool = false;
    this.csvBool = false;
    this.exportViaMail = false;
    this.mailform.reset();
  }

  alldownload(type: string, modal: any) {
    let param = {
      custId: this.custId,
      department: this.selectedDepartment,
      departmentId: this.selectedDepartmentId,
      date: this.fromDate,
      usershiftId: this.selectedShiftId,
      deviceId: 'All Machine',
    };
    this.toastr.warning("please wait while fetching record");
    this.dataservice
      .reportApi(
        "reports/hourlyProduction",
        param
      )
      .subscribe(
        (res) => {
          if (res) {
            if (type === 'pdf') {
              this.pdfBool = true;
              this.csvBool = false;
              this.allMachinedownload(res['tablehourlyData']);
            }

            if (type === 'csv') {
              this.csvBool = true;
              this.pdfBool = false;
              this.allMachinedownload(res['tablehourlyData']);
            }
          }
          modal();
        },
        (err) => {
        }
      );
  }

  allMachinedownload(data: any) {
    if (!this.pdfBool && !this.csvBool) this.pdfBool = true;
    var reportDate = momenttz.tz(this.timezone).format("YYYY-MM-DD HH:mm:ss");

    if (
      this.pdfBool &&
      this.base64String !== undefined &&
      !this.exportViaMail
    ) {
      console.log(data, "----------------data----------------------");

      this.reportType = "Day";

      var pdfName = "Hourly Production Report " + reportDate;
      var today = moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
      var year = moment(new Date()).format("YYYY");

      const contentArray: any[] = [];

      /* ----------------------------------------------------
         COMMON HEADER CONTENT
      ---------------------------------------------------- */

      contentArray.push(
        {
          columns: [
            {
              image: `${this.base64String}`,
              width: 140,
              height: 45,
              alignment: "left",
              margin: [-30, -20, 0, 0],
            },
          ],
        },
        {
          columns: [
            {
              text: "HOURLY PRODUCTION REPORT",
              fontSize: 15,
              bold: true,
              alignment: "center",
              margin: [0, -35, 0, 0],
            },
          ],
        },
        {
          columns: [
            {
              text: "(Date :  " + this.fromDate + ")",
              margin: [0, -10, 0, 0],
              fontSize: 10,
              bold: true,
              alignment: "center",
            },
          ],
        },
        {
          canvas: [
            {
              type: "line",
              lineColor: "#007d79",
              x1: -40,
              y1: 0,
              x2: 2000,
              y2: 0,
              linewidth: 0.5,
            },
          ],
          margin: [0, 0, 0, 6],
        },
        {
          text: "Department : " + this.selectedDepartment,
          fontSize: 11,
          bold: true,
        },
        {
          text: "Shift : " + this.selectedShift,
          fontSize: 11,
          bold: true,
          margin: [0, 5, 0, 8],
        }
      );

      /* ----------------------------------------------------
         LOOP ALL MACHINES
      ---------------------------------------------------- */

      data.forEach((item: any) => {

        const hourlyData = item.partwiseData?.[0] || {};
        const hourArray = item.hourArray || [];

        /* -------- Dynamic Field Detection -------- */

        const hasPin2 = Array.isArray(hourlyData?.Pin2Count);
        const hasBreakdown = Array.isArray(hourlyData?.Breakdown);
        const hasInterlock = Array.isArray(hourlyData?.Interlock);

        /* -------- Machine Name -------- */

        contentArray.push({
          text: "Machine Name : " + item.Machine,
          fontSize: 11,
          bold: true,
          margin: [0, 8, 0, 5],
        });

        /* -------- Dynamic Parameters -------- */

        const parameterKeys = [
          "Availability",
          "Performance",
          "Quality",
          "Oee",
          "Partplanned",
          ...(hasPin2 ? ["Pin1Count", "Pin2Count"] : ["PartProduced"]),
          "PartRejected",
          "Energy",
          "EnergyCost",
          "OppertunityCost",
          "ProductionCost",
          "Running",
          "Idle",
          ...(hasBreakdown ? ["Breakdown"] : []),
          ...(hasInterlock ? ["Interlock"] : []),
          "Off",
          "Downtime",
        ];

        const parameterMap = [
          "Availability(%)",
          "Performance(%)",
          "Quality(%)",
          "Oee(%)",
          "PlannedPart",
          ...(hasPin2 ? ["Pin1Count", "Pin2Count"] : ["PartProduced"]),
          "PartRejected",
          "Energy (kWh)",
          "EnergyCost (₹)",
          "OpportunityCost (₹)",
          "ProductionCost (₹)",
          "Running(hrs)",
          "Idle(hrs)",
          ...(hasBreakdown ? ["Breakdown(hrs)"] : []),
          ...(hasInterlock ? ["Interlock(hrs)"] : []),
          "Off(hrs)",
          "Downtime(hrs)",
        ];

        const timeFields = [
          "Running",
          "Idle",
          ...(hasBreakdown ? ["Breakdown"] : []),
          ...(hasInterlock ? ["Interlock"] : []),
          "Off",
          "Downtime",
        ];

        /* -------- Header Row -------- */

        const headerRow = [
          {
            text: "Parameter",
            fillColor: "#007d79",
            bold: true,
            color: "#fff",
            alignment: "center",
          },
          ...hourArray.map((hour: string) => ({
            text: hour,
            fillColor: "#007d79",
            color: "#fff",
            bold: true,
            alignment: "center",
          })),
        ];

        /* -------- Body Rows -------- */

        const bodyRows = parameterKeys.map((param, i) => {

          const values = Array.isArray(hourlyData[param])
            ? hourlyData[param]
            : new Array(hourArray.length).fill(0);

          return [
            { text: parameterMap[i], bold: true },
            ...values.map((val: any) => ({
              text: timeFields.includes(param)
                ? this.formatMinutesToHHMMSS(val || 0)
                : (val ?? 0).toString(),
              alignment: "center",
            })),
          ];
        });

        /* -------- Table Push -------- */

        contentArray.push({
          fontSize: 7,
          table: {
            headerRows: 1,
            widths: ["auto", ...hourArray.map(() => "auto")],
            body: [headerRow, ...bodyRows],
          },
          layout: {
            fillColor: function (rowIndex: number) {
              return rowIndex === 0
                ? null
                : rowIndex % 2 === 0
                  ? "#9ef0f0"
                  : "#d9fbfb";
            },
            hLineWidth: () => 0.5,
            vLineWidth: () => 0.5,
          },
          margin: [0, 0, 0, 10],
        });

      });

      /* ----------------------------------------------------
         FINAL PDF OBJECT
      ---------------------------------------------------- */

      const pdfObject = {
        pageSize: "A3",
        pageOrientation: "landscape",

        header: function () {
          return {
            text: today,
            alignment: "right",
            margin: [0, 5, 20, 0],
            fontSize: 9,
          };
        },

        footer: function (currentPage: number, pageCount: number) {
          return [
            {
              text: "Page " + currentPage + " of " + pageCount,
              alignment: "center",
              fontSize: 8,
            },
            {
              text: "© " + year + " Wimera Systems Pvt Ltd",
              alignment: "right",
              fontSize: 8,
              margin: [0, 0, 20, 0],
            },
          ];
        },

        content: contentArray,
      };

      pdfMake.createPdf(pdfObject).download(pdfName + ".pdf");



    } else if (this.csvBool && !this.exportViaMail) {
      var res: any[] = [];
      var masterhourlyData = data;

      var title = "Hourly Production Report";
      var startDate = moment(this.fromDate).format("YYYY-MM-DD");
      var duration = "Date : " + startDate;

      res.push([title]);
      res.push([duration]);
      res.push(["Department Name: " + this.selectedDepartment]);
      res.push(["Shift: " + this.selectedShift]);
      res.push([]);

      /* ----------------------------------------------------
         LOOP MACHINES (Dynamic Structure Per Machine)
      ---------------------------------------------------- */

      masterhourlyData.forEach((machineData: any) => {

        const hourlyData = machineData?.partwiseData?.[0] || {};
        const hourArray = machineData?.hourArray || [];

        // ✅ Detect dynamically per machine
        const hasPin2 = Array.isArray(hourlyData?.Pin2Count);
        const hasBreakdown = Array.isArray(hourlyData?.Breakdown);
        const hasInterlock = Array.isArray(hourlyData?.Interlock);

        const parameterKeys = [
          "Availability",
          "Performance",
          "Quality",
          "Oee",
          "Partplanned",
          ...(hasPin2 ? ["Pin1Count", "Pin2Count"] : ["PartProduced"]),
          "PartRejected",
          "Energy",
          "PartwiseEnergy",
          "EnergyCost",
          "OppertunityCost",
          "ProductionCost",
          "Running",
          "Idle",
          ...(hasBreakdown ? ["Breakdown"] : []),
          ...(hasInterlock ? ["Interlock"] : []),
          "Off",
          "Downtime",
        ];

        const parameterMap = [
          "Availability(%)",
          "Performance(%)",
          "Quality(%)",
          "Oee(%)",
          "PlannedPart",
          ...(hasPin2 ? ["Pin1Count", "Pin2Count"] : ["PartProduced"]),
          "PartRejected",
          "Energy (kWh)",
          "Partwise Energy (kWh)",
          "EnergyCost (INR)",
          "OpportunityCost (INR)",
          "ProductionCost (INR)",
          "Running(hrs)",
          "Idle(hrs)",
          ...(hasBreakdown ? ["Breakdown(hrs)"] : []),
          ...(hasInterlock ? ["Interlock(hrs)"] : []),
          "Off(hrs)",
          "Downtime(hrs)",
        ];

        const timeFields = [
          "Running",
          "Idle",
          ...(hasBreakdown ? ["Breakdown"] : []),
          ...(hasInterlock ? ["Interlock"] : []),
          "Off",
          "Downtime",
        ];

        // Machine Name
        res.push([]);
        res.push(["Machine Name: " + machineData.Machine]);

        // Header Row
        const hourHeaderRow = ["Parameter", ...hourArray];
        res.push(hourHeaderRow);

        // Body Rows
        for (let i = 0; i < parameterKeys.length; i++) {

          const key = parameterKeys[i];
          const label = parameterMap[i];

          const values = Array.isArray(hourlyData[key])
            ? hourlyData[key]
            : new Array(hourArray.length).fill(0);

          const row = [
            label,
            ...values.map((val: any) =>
              timeFields.includes(key)
                ? this.formatMinutesToHHMMSS(val || 0)
                : (val ?? 0).toString()
            ),
          ];

          res.push(row);
        }

      });

      /* ----------------------------------------------------
         SAFE CSV DOWNLOAD
      ---------------------------------------------------- */

      const csvContent =
        "data:text/csv;charset=utf-8," +
        res
          .map(row =>
            row
              .map(field => `"${String(field).replace(/"/g, '""')}"`)
              .join(",")
          )
          .join("\n");

      const encodedUri = encodeURI(csvContent);
      const link = document.createElement("a");

      const downloadDate = moment(new Date()).format("YYYY-MM-DD HH_mm_ss");

      link.setAttribute("href", encodedUri);
      link.setAttribute(
        "download",
        `Hourly Production Report ${downloadDate}.csv`
      );

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

    }
    this.pdfBool = false;
    this.csvBool = false;
  }
}
